import { render } from "./AtributosView.vue?vue&type=template&id=54893625"
import script from "./AtributosView.vue?vue&type=script&lang=js"
export * from "./AtributosView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__